import { render, staticRenderFns } from "./branchStore.component.two.vue?vue&type=template&id=313ad195"
import script from "./branchStore.component.two.vue?vue&type=script&lang=js"
export * from "./branchStore.component.two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports